<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>รายการขอรับบริการ</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12">
                        <div class="field">
                            <checkbox v-model="formData.service.checkProblem" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" @change="checkLockProblemDetail($event)">ตรวจเช็คปัญหา</checkbox>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <input v-model="formData.service.problemDetail"
                                    v-show="isShowProblemDetail"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.service.problemDetail.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="ระบุเรื่องการตรวจเช็ค" />
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-6 col-sm-4 col-md-3">
                        <div class="field">
                            <checkbox v-model="formData.service.swapTire" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">บริการสลับยาง</checkbox>
                        </div>
                    </div>
                    <div class="col-6 col-sm-4 col-md-3">
                        <div class="field">
                            <checkbox v-model="formData.service.balanceTire" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">บริการถ่วงล้อ</checkbox>
                        </div>
                    </div>
                    <div class="col-6 col-sm-4 col-md-3">
                        <div class="field">
                            <checkbox v-model="formData.service.inflateTire" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">เติมลมยาง</checkbox>
                        </div>
                    </div>
                    <div class="col-6 col-sm-4 col-md-3">
                        <div class="field">
                            <checkbox v-model="formData.service.fixTire" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">ปะยาง</checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';

export default {
    mixins: [ MixinThemeBoard, MixinFormData],
    data() {
        return {
            formData: null,
            isShowProblemDetail: true
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.isShowProblemDetail = this.formData.service.checkProblem;
            this.$emit('formData', this.formData);
        },
        initForm() {
            return {
                service: {
                    checkProblem: this.loadData ? this.loadData.service.checkProblem : false,
                    problemDetail: this.loadData ? this.loadData.service.problemDetail : '',
                    swapTire: this.loadData ? this.loadData.service.swapTire : false,
                    balanceTire: this.loadData ? this.loadData.service.balanceTire : false,
                    inflateTire: this.loadData ? this.loadData.service.inflateTire : false,
                    fixTire: this.loadData ? this.loadData.service.fixTire : false,
                }
            };
        },
        checkLockProblemDetail(value) {
            this.isShowProblemDetail = value;
            this.formData.service.problemDetail = '';
        }
    }
}
</script>